module.exports = __webpack_public_path__ + "static/media/image12.1aff1919.png";